import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { NumericFormat } from "react-number-format";

function AddConvenioEstadual() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    projeto: "",
    numero_convenio: "",
    ano: "",
    repasse: "",
    contrapartida: "",
    valor_total: "",
    assinatura_termo: "",
    vigencia_convenio: "",
    vigencia_contrato: "",
    empresa: "",
    fiscal: "",
    conta_bancaria: "",
    status: "",
  });

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/conveniosestadual/${id}`)
        .then((res) => {
          setForm({
            projeto: res.data.projeto || "",
            numero_convenio: res.data.numero_convenio || "",
            ano: res.data.ano || "",
            repasse: res.data.repasse || "",
            contrapartida: res.data.contrapartida || "",
            valor_total: res.data.valor_total || "",
            assinatura_termo: res.data.assinatura_termo
              ? res.data.assinatura_termo.split("T")[0]
              : "",
            vigencia_convenio: res.data.vigencia_convenio
              ? res.data.vigencia_convenio.split("T")[0]
              : "",
            vigencia_contrato: res.data.vigencia_contrato
              ? res.data.vigencia_contrato.split("T")[0]
              : "",
            empresa: res.data.empresa || "",
            fiscal: res.data.fiscal || "",
            conta_bancaria: res.data.conta_bancaria || "",
            status: res.data.status || "",
          });
        })
        .catch((err) => {
          console.error(err);
          alert("Erro ao carregar convênio");
        });
    }
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleValueChange = (name, values) => {
    const { value } = values;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (id) {
      // Editar
      axios
        .put(`/api/conveniosestadual/${id}`, form)
        .then((res) => {
          if (res.data.Status === "Success") {
            alert("Convênio ESTADUAL atualizado com sucesso!");
            navigate("/conveniosestadual");
          } else {
            alert("Erro ao atualizar Convênio");
          }
        })
        .catch((err) => {
          console.error(err);
          alert("Erro no servidor");
        });
    } else {
      // Adicionar
      axios
        .post("/api/conveniosestadual", form)
        .then((res) => {
          if (res.data.Status === "Success") {
            alert("Convênio ESTADUAL criado com sucesso!");
            navigate("/conveniosestadual");
          } else {
            alert("Erro ao criar Convênio");
          }
        })
        .catch((err) => {
          console.error(err);
          alert("Erro no servidor");
        });
    }
  };

  return (
    <div className="p-4" style={{ maxWidth: "600px" }}>
      <h3 className="mb-4">
        {id ? "Editar Convênio ESTADUAL" : "Adicionar Convênio ESTADUAL"}
      </h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-2">
          <label>Projeto</label>
          <input
            type="text"
            name="projeto"
            className="form-control"
            required
            value={form.projeto}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>Número do Convênio</label>
          <input
            type="text"
            name="numero_convenio"
            className="form-control"
            required
            value={form.numero_convenio}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>Ano</label>
          <input
            type="number"
            name="ano"
            className="form-control"
            required
            value={form.ano}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>Repasse (R$)</label>
          <NumericFormat
            name="repasse"
            className="form-control"
            required
            value={form.repasse}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale
            onValueChange={(values) => handleValueChange("repasse", values)}
          />
        </div>

        <div className="mb-2">
          <label>Contrapartida (R$)</label>
          <NumericFormat
            name="contrapartida"
            className="form-control"
            required
            value={form.contrapartida}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale
            onValueChange={(values) =>
              handleValueChange("contrapartida", values)
            }
          />
        </div>

        <div className="mb-2">
          <label>Valor Total (R$)</label>
          <NumericFormat
            name="valor_total"
            className="form-control"
            required
            value={form.valor_total}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale
            onValueChange={(values) => handleValueChange("valor_total", values)}
          />
        </div>

        <div className="mb-2">
          <label>Assinatura Termo</label>
          <input
            type="date"
            name="assinatura_termo"
            className="form-control"
            required
            value={form.assinatura_termo}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>Vigência do Convênio</label>
          <input
            type="date"
            name="vigencia_convenio"
            className="form-control"
            required
            value={form.vigencia_convenio}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>Vigência do Contrato</label>
          <input
            type="date"
            name="vigencia_contrato"
            className="form-control"
            required
            value={form.vigencia_contrato}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>Empresa</label>
          <input
            type="text"
            name="empresa"
            className="form-control"
            required
            value={form.empresa}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>Fiscal</label>
          <input
            type="text"
            name="fiscal"
            className="form-control"
            required
            value={form.fiscal}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>Conta Bancária</label>
          <input
            type="text"
            name="conta_bancaria"
            className="form-control"
            required
            value={form.conta_bancaria}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Status</label>
          <input
            type="text"
            name="status"
            className="form-control"
            required
            value={form.status}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-primary">
          {id ? "Salvar Alterações" : "Salvar Convênio"}
        </button>
      </form>
    </div>
  );
}

export default AddConvenioEstadual;
